import { useIsKioskMode } from '../hooks/useIsKioskMode';
import { usePos } from '../hooks/useLoadDiscountData';
import { useMemo } from 'react';
import { Button } from '@mui/material';
import { Replay } from '@mui/icons-material';
import { useUrls } from '../hooks/useUrls';
import { useDealerTheme } from '../hooks/useDealerTheme';

export const useRestartUrl = () => {
  const kiosk = useIsKioskMode();
  const pos = usePos();
  const { restartUrl } = useUrls();
  return useMemo(() => {
    return kiosk && pos ? `${restartUrl}-${pos}` : restartUrl;
  }, [kiosk, pos, restartUrl]);
};

export const RestartButton = () => {
  const url = useRestartUrl();
  const { dealerMain } = useDealerTheme();
  return (
    <Button
      variant="contained"
      target="_parent"
      href={url}
      startIcon={<Replay />}
      sx={{
        backgroundColor: 'white !important',
        color: dealerMain,
        borderRadius: 0,
      }}
    >
      Modellauswahl
    </Button>
  );
};
